import { render } from "./PasswordResetEmailNotice.vue?vue&type=template&id=e513f83a&scoped=true"
import script from "./PasswordResetEmailNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetEmailNotice.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetEmailNotice.vue?vue&type=style&index=0&id=e513f83a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e513f83a"],['__file',"src/views/AppManage/PasswordResetEmailNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e513f83a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e513f83a', __exports__)) {
    api.reload('e513f83a', __exports__)
  }
  
  module.hot.accept("./PasswordResetEmailNotice.vue?vue&type=template&id=e513f83a&scoped=true", () => {
    api.rerender('e513f83a', render)
  })

}


export default __exports__